import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'

import App from './App.vue'
import { router } from './router'

import 'primeicons/primeicons.css'
import './estilos.css'

createApp(App)
  .use(createPinia())
  .use(router)
  .use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        // Sin capas de CSS ajenas peleando con las nuestras, y modo oscuro
        // atado a una clase que controlamos en vez de al sistema: una consola
        // que cambia de color sola a las 6 de la tarde desconcierta.
        darkModeSelector: '.oscuro',
        cssLayer: false,
      },
    },
    locale: {
      accept: 'Sí',
      reject: 'No',
      emptyMessage: 'Sin resultados',
      emptySearchMessage: 'Sin resultados',
      emptySelectionMessage: 'Nada seleccionado',
    },
  })
  .use(ToastService)
  .use(ConfirmationService)
  .directive('tooltip', Tooltip)
  .mount('#app')
